import React from 'react'

const MessageSentIcon = ({ className = '' }) => {
  const classes = 'svg-icon position-icon ' + className

  return (
    <div className={classes}>
      <svg width='134px' height='97px'>
        <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
          <g transform='translate(-416.000000, -747.000000)' id='sent'>
            <g transform='translate(417.000000, 748.000000)'>
              <path
                d='M122.321975,72.2186764 C122.321975,79.5495855 116.361475,85.4928582 109.011475,85.4928582 L13.622475,85.4928582 C6.272475,85.4928582 0.311975,79.5495855 0.311975,72.2186764 L0.311975,13.5836218 C0.311975,6.25271273 6.272475,0.30944 13.622475,0.30944 L109.011475,0.30944 C116.361475,0.30944 122.321975,6.25271273 122.321975,13.5836218 L122.321975,72.2186764 Z'
                fill='#FEFEFE'
              />
              <path
                d='M122.321975,72.2186764 C122.321975,79.5495855 116.361475,85.4928582 109.011475,85.4928582 L13.622475,85.4928582 C6.272475,85.4928582 0.311975,79.5495855 0.311975,72.2186764 L0.311975,13.5836218 C0.311975,6.25271273 6.272475,0.30944 13.622475,0.30944 L109.011475,0.30944 C116.361475,0.30944 122.321975,6.25271273 122.321975,13.5836218 L122.321975,72.2186764 L122.321975,72.2186764 Z'
                stroke='#67B0E7'
                strokeWidth='1.5'
              />
              <path
                d='M119.02025,5.23336727 L67.768,56.3524945 C64.20675,59.90624 58.42825,59.90624 54.86525,56.3524945 L3.613,5.23336727'
                stroke='#67B0E7'
                strokeWidth='1.5'
              />
              <path
                d='M80.060525,44.0850909 L119.020775,82.9424'
                stroke='#67B0E7'
                strokeWidth='1.5'
              />
              <path
                d='M4.82806466,81.830899 L43.148475,43.5104873'
                stroke='#67B0E7'
                strokeWidth='1.5'
              />
              <path
                d='M131.6241,69.9993309 C131.6241,83.6802036 120.50285,94.7708218 106.78635,94.7708218 C93.0681,94.7708218 81.94685,83.6802036 81.94685,69.9993309 C81.94685,56.3167127 93.0681,45.2260945 106.78635,45.2260945 C120.50285,45.2260945 131.6241,56.3167127 131.6241,69.9993309'
                fill='#FEFEFE'
              />
              <path
                d='M131.6241,69.9993309 C131.6241,83.6802036 120.50285,94.7708218 106.78635,94.7708218 C93.0681,94.7708218 81.94685,83.6802036 81.94685,69.9993309 C81.94685,56.3167127 93.0681,45.2260945 106.78635,45.2260945 C120.50285,45.2260945 131.6241,56.3167127 131.6241,69.9993309 L131.6241,69.9993309 Z'
                stroke='#67B0E7'
                strokeWidth='1.5'
              />
              <g transform='translate(97.000000, 61.171520)'>
                <polyline
                  fill='#FEFEFE'
                  points='0.170975 8.00116364 7.452725 15.2674909 21.844725 0.916363636'
                />
                <polyline
                  stroke='#429ADC'
                  strokeWidth='1.5'
                  points='0.170975 8.00116364 7.452725 15.2674909 21.844725 0.916363636'
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  )
}

export default MessageSentIcon
